import React from 'react';
import { Row, Col, NavDropdown, MenuItem, Modal, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { updateNotifications, updateUserById } from '../../actions/UserActions';
import './NavBar.scss';
import SnackBar from '../../components/Snackbar/Snackbar';
import NavMenuJson from './NavMenuJson.json';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditProfilePicture from '../../screens/EditProfile/EditProfilePicture';
import { updateDoctorById, updateAdmin } from '../../actions/BusinessUserActions';

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      browser: 'chrome',
      open: false
    };
  }

  changePasswordScreen = () => {
    this.props.router.push('/changePassword');
  };

  logOutUser = () => {
    // localStorage.removeItem('CogitatioUser');
    if (this.props.userInfo.type === 'user') {
      this.props.dispatch(updateUserById(this.props.userInfo.id, { loggedIn: false }, () => { }));
    } else if (this.props.userInfo.type === 'cogitatioAdmin') {
      this.props.dispatch(updateAdmin(this.props.userInfo.id, () => { }));
    } else {
      this.props.dispatch(updateDoctorById(this.props.userInfo.id, { loggedIn: false }, () => { }));
    }
    localStorage.removeItem('CogitatioUserJWT');
    this.props.router.push('/main');
    window.location.reload();
  };

  usermanagement = () => {
    this.props.router.push('/UserManagement');
  };

  dashboard = () => {
    this.props.router.push('/Dashboard');
  };

  userDashboard = () => {
    this.props.router.push('/UserDashboard');
  };

  pushRouter = (route) => {
    this.props.router.push(route);
  }

  getNotifications = () => {
    return this.props.notifications.map((data) => {
      return <MenuItem eventKey="5.3" style={{ borderBottom: '1px solid #f3f3f3' }}>
        <div style={{ padding: 5 }}>{data.message}</div>
      </MenuItem>
    })
  }

  updatedNotification = (length) => {
    if (length > 0) {
      this.props.dispatch(updateNotifications(this.props.userInfo.id))
    }
  }

  getLogo = () => {
    if (!this.props.logoFlag) {
      if (this.props.businessInfo && this.props.businessInfo.businessLogo) {
        return <img onClick={() => this.props.router.push('/')} src={this.props.businessInfo.businessLogo} width={100} style={{ width: this.props.businessInfo.businessLogoWidth || 200, height: this.props.businessInfo.businessLogoHeight || 50, cursor: 'pointer' }} />
      } else {
        return <div onClick={() => this.props.router.push('/')} className="logo-magic-orbits" style={{ paddingLeft: 10 }}><img src='../../../assets/images/favicon.ico' width={24} height={24} /></div>
      }
    }
  }

  
  onSuccess = () => {
    toast.info(this.props.loadTranslations('Profile updated', this.props.currentLanguage))
    this.setState({ open: false });
  }

  onCancel = () => {
    this.setState({ open: false });
  }

  loadTranslations = (value, currentLanguage) => {
    const currentLang = currentLanguage ? currentLanguage : 'en';
    return this.props.translations ? this.props.translations[value] ? this.props.translations[value][currentLang] ? this.props.translations[value][currentLang] : value : value : value;
  }

  render() {
    const notificationLength = this.props.notifications.filter(val => val.status === 'Active');
    return (
      <div className="navbar admin-nav">
        {this.state.error && this.state.error.indexOf('401') < 0 &&
          <SnackBar
            open={true}
            onClose={() =>
              this.props.dispatch({ type: 'SHOW_ERROR', payload: undefined })
            }
            msg={this.state.error}
          />
        }
        <Row className="full-width">
          <Col lg={4} md={4} sm={5} xs={3}>
            <ToastContainer hideProgressBar={true} position="bottom-right" />
            <ul className="list-inline menu-left">
              <li
                className="list-inline-item logo-sec"
                style={{ color: 'white', fontSize: '23px' }}
              >
                {this.props.businessInfo.businessName}
              </li>
            </ul>
          </Col>
          <Col
            lg={8}
            md={8}
            sm={7}
            xs={9}
            className="text-right profile-wrap np-right"
          >
            <ul className="list-inline" style={{ lineHeight: '20px' }}>
              <li className="list-inline-item notification-list white-border-left min-width-style" style={{ minWidth: '20%' }}>
                <Row>
                  <Col lg={3} md={3} sm={3} xs={3} className="no-padding">
                    <a
                      className="nav-link waves-effect waves-light nav-user"
                      //onClick={() => this.setState({ open: true })}
                    >
                      <img
                        src={this.props.userInfo.profilePicture || "../../assets/images/noprofilepic.jpg"}
                        width="25px"
                        alt="user"
                        className="rounded-circle"
                      />
                    </a>
                  </Col>
                  <Col lg={9} md={9} sm={9} xs={9}>
                    <NavDropdown
                      eventKey="4"
                      title={
                        <span style={{ color: '#ffffff' }}>{this.loadTranslations('Me', this.props.currentLanguage)}</span>
                      }
                      id="nav-dropdown"
                    ><MenuItem eventKey="1">
                        {/* <img
                          src="../../assets/images/noprofilepic.jpg"
                          alt="user"
                          height={25}
                          width={25}
                          className="rounded-circle"
                        /> */}
                        {this.props.userInfo ? `${this.props.userInfo.firstName} ${this.props.userInfo.lastName}` : ''}
                      </MenuItem>
                      {/* <MenuItem eventKey="4.3" onClick={() => this.props.router.push('/settings')}>
                        {this.loadTranslations('Settings', this.props.currentLanguage)}
                      </MenuItem>
                      <MenuItem eventKey="4.3" onClick={() => this.props.router.push('/feedback')}>
                        {this.loadTranslations('Feedback', this.props.currentLanguage)}
                      </MenuItem> */}
                      <MenuItem divider />
                      <MenuItem eventKey="4.3" onClick={this.logOutUser}>
                        {this.loadTranslations('Log Out', this.props.currentLanguage)}
                      </MenuItem>
                    </NavDropdown>
                  </Col>
                </Row>
              </li>
            </ul>
            <Modal dialogClassName="modal-50w" show={this.state.open} onHide={() => this.onClose()}>
              <br />
              <EditProfilePicture onSuccess={this.onSuccess} onCancel={this.onCancel} loadTranslations={this.loadTranslations} />
              <br />
            </Modal>
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userInfo: state.users.userInfo,
    notifications: state.users.notifications,
    businessInfo: state.users.businessInfo,
    userInfo: state.users.userInfo,
    currentLanguage: state.users.currentLanguage,
    translations: state.users.translations
  };
}
export default connect(mapStateToProps)(NavBar);



// WEBPACK FOOTER //
// ./screens/NavBar/NavBar.js